import React, { useEffect, lazy, createElement } from 'react';
import { SEO } from '../components/SEO';
export function OwnerSubmitPage() {
  useEffect(() => {
    // Load Tally embed script
    const script = document.createElement('script');
    script.src = 'https://tally.so/widgets/embed.js';
    script.async = true;
    script.onload = () => {
      if (typeof (window as any).Tally !== 'undefined') {
        ;
        (window as any).Tally.loadEmbeds();
      }
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <>
      <SEO title="Submit a Property — Aspect" description="Submit a completed property for documentation with clear usage and visibility controls." data-id="element-545" />
      <div className="max-w-3xl mx-auto" data-id="element-546">
        <h1 className="text-3xl md:text-4xl font-medium leading-tight mb-6 text-aspect-black" data-id="element-547">
          Submit a property
        </h1>
        <p className="text-lg text-aspect-black/80 mb-8" data-id="element-548">
          Submit a completed property for documentation with clear usage and
          visibility controls.
        </p>

        <p className="text-sm text-aspect-gray mb-12" data-id="element-549">
          Owners retain approval authority over what is photographed and how
          images are used.
        </p>

        <div className="w-full" style={{
        colorScheme: 'light',
        backgroundColor: '#F6F7F5'
      }} data-id="element-550">
          <iframe data-tally-src="https://tally.so/embed/yPNe9d?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1" loading="lazy" width="100%" height="1054" frameBorder="0" marginHeight={0} marginWidth={0} title="Owner Property Submission" className="w-full" data-id="element-551" />
        </div>
      </div>
    </>;
}